import React from "react";

const Frame88 = () => {
      return(
            <div className="all-right-reserved-copyright-parent">
                  <div className="about">All Right Reserved @Copyright 2023</div>
                  <div className="frame-parent10">
                        <div className="terms-of-service-parent">
                              
                              <div className="about">Terms of Service</div>
                              <div className="about">Privacy Policy</div>
                              <div className="about">Product</div>
                        </div>
                        <div className="mdifacebook-parent">
                              <img className="mdifacebook-icon" alt="" src="/mdifacebook.svg" />
                              <img className="mdifacebook-icon" alt="" src="/uilyoutube.svg" />
                              <img className="mdifacebook-icon" alt="" src="/basilinstagramsolid.svg" />
                              <img className="mdifacebook-icon" alt="" src="/uiltwitter.svg" />
                        </div>
                  </div>
            </div>
      );
};

export default Frame88;